<template>
  <div v-if="data && data.organization" class="row-box">
    <!-- основная информация: start -->
    <WrapperField
      v-for="(value, index) in baseInfo"
      :key="value + index"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.ORGANIZATION,
        })
      "
    ></WrapperField>
    <!-- основная информация: end -->

    <!-- ФИО лица, имеющего право без доверенности действовать от имени юридического лица: start -->
    <TitleField
      v-if="model.isAssignee"
      :fieldName="'isAssignee'"
      :fieldGroup="FieldGroup.ORGANIZATION"
    />
    <AssigneeSection
      v-if="model.isAssignee"
      :data="model.assignee"
      :documents-hidden="trusteeDocumentsHidden"
    />
    <!-- ФИО лица, имеющего право без доверенности действовать от имени юридического лица: end -->

    <!-- представитель: start -->
    <template v-if="data.organization.isTrustee">
      <TitleField fieldName="isTrustee" :fieldGroup="FieldGroup.ORGANIZATION" />
      <TrusteeSection
        v-if="data.organization.trusteeInfo"
        :data="trusteeInfoData"
        :documents-hidden="
          trusteeDocumentsHidden || trusteeDocumentsHiddenInner
        "
      />
      <TrusteeOrganization
        v-if="data.organization.trusteeOrganizationInfo"
        :data="data.organization.trusteeOrganizationInfo"
      />
      <TrusteeForeignOrganization
        v-if="data.organization.trusteeForeignOrganizationInfo"
        :data="data.organization.trusteeForeignOrganizationInfo"
      />
    </template>
    <!-- представитель: end -->
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import TrusteeOrganization from '@/components/elements/statement/FullStatementView/elements/TrusteeOrganization';
import TrusteeForeignOrganization from '@/components/elements/statement/FullStatementView/elements/TrusteeForeignOrganization';
import AssigneeSection from '@/components/elements/statement/FullStatementView/elements/Assignee';
import { StatementType } from '@/types/services';
import cloneDeep from 'clone-deep';

const ORGANIZATION_ORDER = [
  'name',
  'ogrn',
  'inn',
  'kpp',
  'address',
  'addressNote',
  'factAddress',
  'regDate',
  'email',
  'phone',
  'isAssignee',
  'isTrustee',
];

export default {
  name: 'Organization',
  components: {
    WrapperField,
    TitleField,
    TrusteeSection,
    TrusteeOrganization,
    TrusteeForeignOrganization,
    AssigneeSection,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    statementType: {
      type: String,
    },
    trusteeDocumentsHidden: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  computed: {
    baseInfo() {
      const info = {};

      ORGANIZATION_ORDER.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.data.organization, key)) {
          info[key] = this.data.organization[key];
        }
      });

      return info;
    },

    trusteeDocumentsHiddenInner() {
      return [StatementType.ROD].includes(this.statementType);
    },
    model() {
      if (!this.data || !this.data.organization) return undefined;
      if (
        !this.data.organization.isAssignee ||
        this.data.organization.assignee
      ) {
        return this.data.organization;
      }
      const {
        assigneeLastName,
        assigneeName,
        assigneePatronymic,
        assigneeSnils,
        ...data
      } = this.data.organization;

      return {
        ...data,
        assignee: {
          lastName: assigneeLastName,
          name: assigneeName,
          patronymic: assigneePatronymic,
          snils: assigneeSnils,
        },
      };
    },
    trusteeInfoData() {
      if (this.trusteeDocumentsHidden) {
        const res = cloneDeep(this.data.organization.trusteeInfo);
        delete res.trusteeStatus;

        return res;
      }

      return this.data.organization.trusteeInfo;
    },
  },
};
</script>
